import { render, staticRenderFns } from "./imgMainCarousel.vue?vue&type=template&id=07121c9a&scoped=true&"
import script from "./imgMainCarousel.vue?vue&type=script&lang=js&"
export * from "./imgMainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./imgMainCarousel.vue?vue&type=style&index=0&id=07121c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07121c9a",
  null
  
)

export default component.exports